<template>
  <div class="vt-video" v-definesize="autoSize">
    <!-- Poster -->
    <div v-if="!autoplay && !loading" :class="['vt-video__poster lazyload', { 'vt-video__poster--active' : playing }]" 
    :data-bgset="`${this.poster}?mw=800 [(max-width: 767px)] | ${this.poster}?mw=1280`">
      <a v-if="!loading" class="button button--pause" @click="changeStatus">
        <svg>
          <use xlink:href="#icon-play" />
        </svg>
      </a>
    </div>
    <!-- Video -->
    <div v-show="loading" class="nt-loading nt-loading--block">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
    <div v-show="!loading" :id="id" style="width:100%; height:100%" @click="changeStatus"></div>
  </div>
</template>

<script>
/* eslint-disable */
  export default {
    name: 'VideoYouku',
    props: {
      autoplay: {
        type: Boolean,
        default: false
      },
      poster: {
        type: String,
        default: null,
        required: true
      },
      videoUrl: {
        type: String,
        default: null,
        required: true
      },
      autoSize: {
        type: Boolean,
        default: true,
        required: true
      },
      clientId: {
        type: String,
        default: '7eda48c63683707c'
      }
    },
    data() {
      return {
        id: `video-${Math.floor(Math.random() * 100000)}`,
        playing: false,
        player: null,
        loading: true
      }
    },
    watch: {
      playing(isPlaying) {
        if (isPlaying) {
          this.player.playVideo()
        } else {
          this.player.pauseVideo()
        }
      }
    },
    created() {
      window.addEventListener('onLoadYoukuPlayer', this.onLoadYoukuPlayer)

      this.$root.$on('changeVideo', (payload) => {
        if (payload.id === this.id) {
          switch (payload.command) {
            case 'pause':
              if (!this.playing) return

              this.playing = false
              break;
            case 'stop':
              if (this.playing) {
                this.player.seekTo(0)
              }
              this.playing = false
              break;
            default:
              window.console.warn(`Command ${payload.command} not found.`)
              break;
          }
        }
      })
    },
    mounted() {
      this.player = new YKU.Player(this.id, {
        styleid: '0',
        client_id: this.clientId,
        vid: this.videoUrl,
        newPlayer: true,
        show_related: false,
        autoplay: this.autoplay,
        events: {
          onPlayerReady: this.onYoukuPlayerReady
        }
      })
    },
    methods: {
      changeStatus() {
        this.playing = !this.playing
      },
      onLoadYoukuPlayer(data) {
        const el = document.getElementById(this.id)

        if (el) {
          el.style.width = '100%'
          el.style.height = '100%'
        }

        if(data.detail === this.id && this.autoplay) {
          this.playing = true
        }
        this.loading = false
      }
    }
  }
</script>

<style lang="scss" scoped>
.vt-video {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  &__poster {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f8f8f8;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 99;

    &--active {
      visibility: hidden;
    }
  }
}
</style>
